export default (context) => {
	context.store.dispatch("account/GET_LOCATION");
};
